import { render, staticRenderFns } from "./DashboardOrders.vue?vue&type=template&id=fb011676&scoped=true&"
var script = {}
import style0 from "./DashboardOrders.vue?vue&type=style&index=0&id=fb011676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb011676",
  null
  
)

export default component.exports